import KunLoading30 from './src/index'

KunLoading30.install = function (Vue) {
	Vue.component(KunLoading30.name, KunLoading30);
}

export default KunLoading30;
